import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom' 
import GlobalStyles from './globalStyles'
import { Navbar, Footer } from './components';
import Home from './pages/HomePage/Home';
import Services from './pages/Services/Services';
import Products from './pages/Products/Products';
import ScrollToTop from './components/ScrollToTop';
import { FloatButton,Tooltip  } from 'antd';
//import 'antd/dist/reset.css';
import { WhatsAppOutlined  } from '@ant-design/icons';


function App() {

    const phoneNumber = "+526673050222";
    const message = "Hola! Me gustaría saber más sobre sus servicios.";
    const encodedMessage = encodeURIComponent(message);
    const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

  const stylesFn = {
  root: {
    backgroundColor: '#25D366', 
    height: 60,
    width: 60,
   
  },
  
};
  return (
    
      <Router>
          <GlobalStyles />
          <ScrollToTop />
          <Navbar />
          <Switch>
            <Route path='/' exact component={Home} />
            <Route path='/services' component={Services} />
            <Route path='/products' component={Products} />
          </Switch>
          <Footer />
        <Tooltip title="Contactanos, un especialista te espera para resolver cualquier duda! 	&#128522;" >
             <FloatButton  icon= {<WhatsAppOutlined style={{ color: '#fff',fontSize: '60px'}}/>} href={whatsappLink} styles={stylesFn} target="_blank" rel="noopener noreferrer"/>
             
       </Tooltip>      
             
           
            
      </Router>
        
    
  );
}

export default App;


